import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Routes } from "src/app/core/constants/routes";
import { Message } from "src/app/core/class/message";
import { CommonService } from "src/app/core/services/common.service";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-page-error-api-limit",
  templateUrl: "./page-error-api-limit.component.html",
  styleUrls: ["./page-error-api-limit.component.scss"],
})
export class PageErrorApiLimitComponent
  extends BaseComponent
  implements OnInit
{
  public href: string = "";
  public linkHome: string = "";
  messages: string = "";
  isApprovedError: boolean = false;
  messageApprovedError: string = "";
  constructor(
    private router: Router,
    public commonService: CommonService,
    public message: Message,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    super(commonService, message);
    //this.messages = this.router.getCurrentNavigation().extras.state.message;
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.queryParams["errorCode"] === "Approved") {
      this.isApprovedError = true;
      this.messageApprovedError =
        this.activatedRoute.snapshot.queryParams["errorCode"];
    }
    this.setLinkHomeValue();
  }

  /*
   * Get current URL an check to routerLink to the fit page
   */
  setLinkHomeValue() {
    this.href = this.router.url;
    if (this.href.includes(Routes.ENTERPRISE_HOME)) {
      this.linkHome = Routes.SLASH + Routes.ENTERPRISE_HOME;
    }
  }

  login() {
    this.router.navigate([Routes.SLASH + Routes.ENTERPRISE_LOGIN]);
  }

  /**
   * <pre>
   * <b>Method name: onChangeLanguage</b>
   * <b>Explanation: </b> Method setting change langauge
   * </pre>
   * @author GCS 2019/08/26 by phuongtq
   *
   */
  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }
}
